import LoginSSOForm from '../components/login-sso-form';
import { ThemeLayout } from '../components/theme/theme-layout';

function LoginSSO() {
  return (
    <ThemeLayout>
      <LoginSSOForm />
    </ThemeLayout>
  );
}

export default LoginSSO;
